import { type JSX, lazy, Suspense, useEffect } from "react"
import { Words } from "./Words"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { Timer } from "./Timer"
import { getWordsAsync, resetHome } from "./homeSlice"
// import { Chart } from './Chart'
import { RotateCcw } from "lucide-react"
import { Dashboard } from "./Dashboard"
import { Button } from "@/components/ui/button"
import { toast } from "sonner"

const EndScreen = lazy(() => import("./EndScreen"))

export const Home = (): JSX.Element | false => {
  const homeSlice = useAppSelector(state => state.home)
  const dispatch = useAppDispatch()

  // reset game on enter key press
  useEffect(() => {
    function focusInputField(event: KeyboardEvent) {
      if (event.code === "Escape") dispatch(resetHome())
    }
    window.addEventListener("keydown", focusInputField)
    return () => {
      window.removeEventListener("keydown", focusInputField)
      dispatch(resetHome())
    }
  }, [])

  return (
    <div className="flex flex-col flex-1 items-center justify-evenly">
      {homeSlice.gameState !== "finished" ? (
        <>
          {/* <div>input: {homeSlice.inputWords.join(' ')}</div>
          <div>naput: {homeSlice.nativeInputWords.join(' ')}</div> */}
          <Button className="opacity-0" />
          <Dashboard />
          <Words />
          <Timer />
        </>
      ) : (
        <Suspense fallback={<div>Loading</div>}>
          <>
            <Button className="opacity-0" />
            <EndScreen />
          </>
        </Suspense>
      )}
      <div
        className="cursor-pointer"
        onClick={() => {
          dispatch(resetHome())
          //   dispatch(setForeignLanguage(homeSlice.nativeLanguage)) // trigger fetchWords
          try {
            void dispatch(getWordsAsync())
          } catch (error) {
            toast.error("Failed to fetch words")
            console.error("Failed to fetch words: ", error)
          }
        }}
      >
        <RotateCcw />
      </div>
    </div>
  )
}
